((ProductDescription, $) => {
  'use strict';

  const hiddenClass = 'hidden';

  let $sensationList;
  let $variants;
  let $imageContainer;
  let $image;
  let $descriptionContainer;
  let $sleeve1;
  let $sleeve2;
  let $sleeve3;
  let $dildo;
  let $quickshot;
  let $variantDescription;
  let $lengthContainer;
  let $length;
  let $insert;

  const cacheDom = () => {
    $sensationList = $('.js-sensation-list');
    $variants = $sensationList.find('.js-single-variant');
    $imageContainer = $('.js-product-texture-image-container ');
    $image = $imageContainer.find('.js-product-texture-image');
    $descriptionContainer = $('.js-product-texture-description-section');
    $sleeve1 = $descriptionContainer.find('.js-sleeve-1-description')
    $sleeve2 = $descriptionContainer.find('.js-sleeve-2-description');
    $sleeve3 = $descriptionContainer.find('.js-sleeve-3-description');
    $dildo = $descriptionContainer.find('.js-dildo-description');
    $quickshot = $descriptionContainer.find('.js-quickshot-description');
    $variantDescription = $descriptionContainer.find('.js-variant-description');
    $lengthContainer = $('.js-product-length-item-container');
    $length = $lengthContainer.find('.js-product-length');
    $insert = $lengthContainer.find('.js-product-insert');
  };

  const updateText = (type, index) => {
    const err = new Error('Wrong type provided to updateText function.');

    $variantDescription.not(`.${hiddenClass}`).addClass(hiddenClass);

    switch (type) {
      case 'sleeve':
        if (index === 1) {
          $sleeve1.removeClass(hiddenClass);
        } else if (index === 2) {
          $sleeve2.removeClass(hiddenClass);
        } else {
          $sleeve3.removeClass(hiddenClass);
        }
        break;
      case 'dildo':
        $dildo.removeClass(hiddenClass);
        break;
      case 'quickshot':
      $quickshot.removeClass(hiddenClass);
        break;
      default:
        throw err;
    }
  }

  const updateSizes = (length, insert) => {
    $length.text(length);
    $insert.text(insert);
  }

  const bindUIActions = () => {
    $variants.on('click', function (event) {
      const imageUrl = $(this).data('description-image');
      const length = $(this).data('length');
      const insert = $(this).data('insert');
      const type = $(this).data('item-type');
      const index = $(this).data('item-number');

      updateSizes(length, insert);
      updateText(type, index);

      $image.attr('src', imageUrl);
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  ProductDescription.init = init;

})(window.ProductDescription = window.ProductDescription || {}, jQuery);
